var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main_center lawEnforcement_detail" }, [
    _c("div", { staticClass: "top-content" }, [
      _c(
        "div",
        { staticClass: "left-navbar" },
        [_c("el-button", { on: { click: _vm.backRouter } }, [_vm._v("返回")])],
        1
      ),
    ]),
    _c(
      "div",
      { staticClass: "right-content" },
      [
        _c(
          "el-form",
          { ref: "form", attrs: { model: _vm.form, "label-width": "200px" } },
          [
            _c(
              "el-card",
              { staticClass: "box-card" },
              [
                _c(
                  "div",
                  {
                    staticClass: "clearfix",
                    attrs: { slot: "header" },
                    slot: "header",
                  },
                  [_c("span", [_vm._v("监督人员登记信息")])]
                ),
                _c(
                  "el-row",
                  [
                    _c(
                      "el-col",
                      { attrs: { span: _vm.num / 2 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "状态：", prop: "status" } },
                          [
                            _c("span", [
                              _vm._v(_vm._s(_vm.form.status ? "启用" : "禁用")),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: _vm.num / 2 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: "人员类型：", prop: "personType" },
                          },
                          [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.form.personType == "1"
                                    ? "开评标监督人员"
                                    : "其他"
                                )
                              ),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  [
                    _c(
                      "el-col",
                      { attrs: { span: _vm.num } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "参与权限：",
                              prop: "participationRights",
                            },
                          },
                          [
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.form.participationRightsName || "--")
                              ),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  [
                    _c(
                      "el-col",
                      { attrs: { span: _vm.num / 2 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "姓名：", prop: "personName" } },
                          [_vm._v(" " + _vm._s(_vm.form.personName) + " ")]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: _vm.num / 2 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "手机号：", prop: "phone" } },
                          [_vm._v(" " + _vm._s(_vm.form.phone) + " ")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  [
                    _c(
                      "el-col",
                      { attrs: { span: _vm.num / 2 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "身份证号：", prop: "idNo" } },
                          [_vm._v(" " + _vm._s(_vm.form.idNo) + " ")]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: _vm.num / 2 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: "所属监督部门：", prop: "deptId" },
                          },
                          [_vm._v(" " + _vm._s(_vm.form.deptName) + " ")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  [
                    _c(
                      "el-col",
                      { attrs: { span: _vm.num } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "主要工作内容：",
                              prop: "workContent",
                            },
                          },
                          [_vm._v(" " + _vm._s(_vm.form.workContent) + " ")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-card",
              { staticClass: "box-card" },
              [
                _c(
                  "div",
                  {
                    staticClass: "clearfix",
                    attrs: { slot: "header" },
                    slot: "header",
                  },
                  [_c("span", [_vm._v("相关附件")])]
                ),
                _c(
                  "el-row",
                  _vm._l(_vm.form.attachments, function (item, index) {
                    return _c(
                      "el-col",
                      { key: index, attrs: { span: _vm.num } },
                      [
                        _c("affix-doc", {
                          staticClass: "affixDown",
                          attrs: {
                            item: item,
                            name: item.fileTypeName,
                            type: "person_register_att",
                            labelWidth: "200px",
                          },
                          on: {
                            "update:item": function ($event) {
                              item = $event
                            },
                          },
                        }),
                      ],
                      1
                    )
                  }),
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }